import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ChevronRight = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chevron-right-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.69136 3.24018C5.43101 3.50053 5.43101 3.92264 5.69136 4.18299L9.50773 7.99937L5.69136 11.8157C5.43101 12.0761 5.43101 12.4982 5.69136 12.7586C5.9517 13.0189 6.37382 13.0189 6.63416 12.7586L10.9219 8.47078C11.1823 8.21043 11.1823 7.78832 10.9219 7.52797L6.63417 3.24018C6.37382 2.97983 5.95171 2.97983 5.69136 3.24018Z"
    />
  </SVGIcon>
);
